"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The runtime entry — `@stem/lab-schema/runtime`.
 *
 * Everything needed to *interpret* and *grade* a lab, and nothing needed to
 * validate one. No zod, which is about 100 kB uncompressed that a learner
 * opening a lab on a 2G connection would otherwise pay for a validator they
 * will never run. The server, the pack authoring code and the preview harness
 * import `@stem/lab-schema` and get the schemas.
 *
 * The types are still here — they are erased at build time, so a runtime that
 * is fully typed against the DSL costs nothing at all.
 */
__exportStar(require("./pure"), exports);
__exportStar(require("./grading"), exports);
//# sourceMappingURL=runtime.js.map